/**
 * @file token
 * @Author ytyjm
 * @Create 14:52 2020/5/26
 * @Version 1.0
 * @Description:
 */
export const getToken=()=>{
  return ''
}
